import { NextRouter, useRouter } from 'next/router';

import { buildQueryParamsString } from '@zoopla/listing-search-utils';

const generateFromCurrPage = (router: NextRouter, link: string) => {
    let currentURL = router.asPath;

    if (router?.query?.['return_url'] || router?.query?.['page_after_login']) {
        const newQuery = { ...router.query };
        delete newQuery['return_url'];
        delete newQuery['page_after_login'];
        currentURL = `${router.pathname}/${buildQueryParamsString(
            newQuery,
            router.query['pn'] ? Number(router.query['pn']) : 1
        )}`;
    }

    return `${link}?page_after_login=${encodeURIComponent(
        currentURL
    )}&return_url=${encodeURIComponent(currentURL)}`;
};

const generateFromParam = (
    router: NextRouter,
    link: string,
    withConfirmation = false
) => {
    if (
        !(router?.query?.['return_url'] || router?.query?.['page_after_login'])
    ) {
        return `${link}${withConfirmation ? '?with_confirmation=true' : ''}`;
    }

    const confirmation = withConfirmation ? '&with_confirmation=true' : '';

    const path = (router.query['return_url'] ||
        router.query['page_after_login']) as string;
    return `${link}?page_after_login=${encodeURIComponent(
        path
    )}&return_url=${encodeURIComponent(path)}${confirmation}`;
};

/**
 * Returns a link with return param (i.e. both return_url & page_after_login)
 * @param {string} link the target path you want to navigate to, default as `/signin/`
 */
export const useLinkWithParam = (
    link = '/signin/',
    withConfirmation = false
) => {
    const router = useRouter();
    const returnBlackList = new Set(['/register', '/signin']);
    const isRegOrSigninPage =
        router.pathname && returnBlackList.has(router.pathname);

    if (!isRegOrSigninPage) {
        return generateFromCurrPage(router, link);
    }

    return generateFromParam(router, link, withConfirmation);
};
